import { c as _c } from "react/compiler-runtime";
import React, { useState, useContext, useMemo, useCallback } from 'react';
import { colorBrand } from 'styles/layout/colors';
import IconMapMarker from 'components/icons/IconMapMarker';
import avo from 'analytics/avo';
import useProductCardContext from 'data-hooks/useProductCardContext';
import CategoryStoresContext from 'data-hooks/context/CategoryStoresContext';
import ProductCardMultipleStoresModal from './ProductCardMultipleStoresModal';
const ProductCardOnDisplayInShowroomMultiple = () => {
  const $ = _c(33);
  const productCardContext = useProductCardContext();
  const {
    storesLookup,
    productStoresMap,
    productDistancesMap
  } = useContext(CategoryStoresContext);
  const [modalOpen, setModalOpen] = useState(false);
  const productId = productCardContext?.id;
  let t0;
  if ($[0] !== productDistancesMap || $[1] !== productId || $[2] !== productStoresMap || $[3] !== storesLookup) {
    bb0: {
      const storeIds = productStoresMap[productId] || [];
      let t1;
      if ($[5] !== productDistancesMap || $[6] !== productId) {
        t1 = productDistancesMap[productId] || [];
        $[5] = productDistancesMap;
        $[6] = productId;
        $[7] = t1;
      } else {
        t1 = $[7];
      }
      const distances = t1;
      if (!storeIds || storeIds.length === 0) {
        let t2;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = [];
          $[8] = t2;
        } else {
          t2 = $[8];
        }
        t0 = t2;
        break bb0;
      }
      let t2;
      if ($[9] !== distances || $[10] !== storesLookup) {
        t2 = (storeId, index) => {
          const storeData = storesLookup[storeId];
          if (!storeData) {
            return null;
          }
          return {
            storeData,
            distance: distances[index] || 0
          };
        };
        $[9] = distances;
        $[10] = storesLookup;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      t0 = storeIds.map(t2).filter(Boolean);
    }
    $[0] = productDistancesMap;
    $[1] = productId;
    $[2] = productStoresMap;
    $[3] = storesLookup;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const stores = t0;
  let t1;
  if ($[12] !== modalOpen || $[13] !== stores) {
    t1 = () => {
      if (!modalOpen) {
        const firstStore = stores[0];
        const firstStoreLocation = `${firstStore?.storeData?.city}, ${firstStore?.storeData?.state}`;
        const hasMultipleStores = stores.length > 1;
        const remainingCount = stores.length - 1;
        const displayText = hasMultipleStores ? `${firstStoreLocation} +${remainingCount} more` : firstStoreLocation;
        avo.ctaClicked({
          text: `On display in ${displayText}`,
          targetUrl: "",
          cta: "Retail Store",
          component: "Side Panel",
          location: "Category Page"
        });
      }
      setModalOpen(!modalOpen);
    };
    $[12] = modalOpen;
    $[13] = stores;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  const toggleModal = t1;
  if (!stores || stores.length === 0) {
    return null;
  }
  const firstStore_0 = stores[0];
  const firstStoreLocation_0 = `${firstStore_0?.storeData?.city}, ${firstStore_0?.storeData?.state}`;
  const hasMultipleStores_0 = stores.length > 1;
  const remainingCount_0 = stores.length - 1;
  let t2;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-xs font-bold text-gray-light2">On display in </span>;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span><IconMapMarker height={12} width={12} color={colorBrand} /></span>;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== hasMultipleStores_0 || $[18] !== remainingCount_0) {
    t4 = hasMultipleStores_0 && <span className="text-gray-light2 ml-2">+{remainingCount_0} more</span>;
    $[17] = hasMultipleStores_0;
    $[18] = remainingCount_0;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== firstStoreLocation_0 || $[21] !== t4) {
    t5 = <span className="text-xs font-bold text-brand hover:no-underline flex space-x-1 items-center">{t3}<span>{firstStoreLocation_0}{t4}</span></span>;
    $[20] = firstStoreLocation_0;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t5 || $[24] !== toggleModal) {
    t6 = <button className="flex flex-col md:flex-row md:items-center items-start text-xs font-bold text-brand pb-1 text-left md:p-0" onClick={toggleModal} type="button" aria-label="Open Showroom">{t2}{t5}</button>;
    $[23] = t5;
    $[24] = toggleModal;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setModalOpen(false);
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== modalOpen || $[28] !== stores) {
    t8 = <ProductCardMultipleStoresModal stores={stores} onClose={t7} isOpen={modalOpen} />;
    $[27] = modalOpen;
    $[28] = stores;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t6 || $[31] !== t8) {
    t9 = <div className="text-xs font-bold text-brand pb-1 text-left md:p-0">{t6}{t8}</div>;
    $[30] = t6;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
};
export default ProductCardOnDisplayInShowroomMultiple;